import { bubEvents } from 'shared/events/bub_events';

$(document).ready(() => {
  const shoppingCartCountIcon = $('#header-shopping-cart-number');
  const shoppingCartLink = $('.header-shopping-cart .shopping-cart-link');

  const shoppingCartDropdown = $('#shopping-cart-dropdown-wrapper');
  const shoppingCartDropdownToggle = $('.header-shopping-cart .shopping-cart');
  const closeDropdownDelayMs = 1000;
  const openDropdownDelayMs = 300;

  let closeDropdownTimer;
  let openDropdownTimer;
  let dropdownOpen = false;

  if (shoppingCartCountIcon.length) {
    // Icon with number of items
    let shoppingCartCount = parseInt(shoppingCartCountIcon.text(), 10) || 0;
    let countVisible = shoppingCartCount > 0;

    const hideCartCount = () => {
      countVisible = false;
      shoppingCartCountIcon.addClass('hidden');
      shoppingCartLink.attr('aria-label', 'Disabled: Your shopping cart is empty');
    };

    const showCartCount = () => {
      countVisible = true;
      shoppingCartCountIcon.removeClass('hidden');
      shoppingCartLink.removeAttr('aria-label');
    };

    const setCartCount = number => {
      shoppingCartCount = number > 0 ? number : 0;
      if (shoppingCartCount > 99) {
        shoppingCartCountIcon.text('+');
      } else {
        shoppingCartCountIcon.text(shoppingCartCount);
      }

      if (shoppingCartCount > 0 && !countVisible) {
        showCartCount();
      } else if (shoppingCartCount === 0 && countVisible) {
        hideCartCount();
      }
    };

    // disable link if there are no items in cart
    shoppingCartLink.click(() => {
      if (shoppingCartCount === 0) {
        return false;
      }
      return true;
    });

    shoppingCartCountIcon.on('increment', () => {
      shoppingCartCountIcon.addClass('large');
      setTimeout(() => shoppingCartCountIcon.removeClass('large'), 500);
      setCartCount(shoppingCartCount + 1);
    });

    $(document).on('click touch', '*[data-shopping-cart="remove"]', () => {
      setCartCount(shoppingCartCount - 1);
    });

    $('.shopping-cart-link').click(() => {
      bubEvents.track('Header', 'Clicked link', {
        label: 'Clicked shopping cart icon',
      });
    });

    // Drop down
    if (shoppingCartDropdown.length) {
      const openDropdown = () => {
        dropdownOpen = true;
        shoppingCartDropdown.load('/shopping_cart_items/load_for_header');
        shoppingCartDropdown.addClass('active');
      };

      const closeDropdown = () => {
        dropdownOpen = false;
        shoppingCartDropdown.removeClass('active');
      };

      const onMouseAwayFromDropdown = () => {
        if (dropdownOpen) {
          closeDropdownTimer = setTimeout(() => {
            closeDropdown();
          }, closeDropdownDelayMs);
        } else {
          clearTimeout(openDropdownTimer);
        }
      };

      const onMouseOverCart = () => {
        if (!dropdownOpen) {
          openDropdownTimer = setTimeout(() => {
            openDropdown();
            bubEvents.track('Header', 'Hovered nav', {
              label: 'Shopping cart icon',
            });
          }, openDropdownDelayMs);
        } else {
          clearTimeout(closeDropdownTimer);
        }
      };

      const isClickOutsideDropdown = targetElement => shoppingCartDropdown.has(targetElement).length === 0;
      const isClickOutsideToggle = targetElement => shoppingCartDropdownToggle.has(targetElement).length === 0;

      $(document).on('click touch', event => {
        if (dropdownOpen && isClickOutsideDropdown(event.target) && isClickOutsideToggle(event.target)) {
          closeDropdown();
        }
      });

      // `mouseenter` works as both hover and mobile tap
      shoppingCartDropdownToggle.mouseenter(onMouseOverCart);

      shoppingCartDropdownToggle.mouseleave(onMouseAwayFromDropdown);

      shoppingCartDropdown.mouseenter(() => {
        clearTimeout(closeDropdownTimer);
      });

      shoppingCartDropdown.mouseleave(onMouseAwayFromDropdown);

      shoppingCartDropdown.on('click', '.shopping-cart-additional-books', () => {
        bubEvents.track('Shopping cart dropdown', 'Clicked link', {
          label: 'More items',
        });
      });

      shoppingCartDropdown.on('click', '.shopping-cart-view-cart-button', () => {
        bubEvents.track('Shopping cart drop down', 'Clicked button', {
          label: 'View cart',
        });
      });

      shoppingCartDropdown.on('click', '.shopping-cart-checkout-button', () => {
        bubEvents.track('Shopping cart drop down', 'Clicked button', {
          label: 'Checkout',
        });
      });

      shoppingCartDropdown.on('click', '.shopping-cart-item-audiobook-cover', event => {
        bubEvents.track('Shopping cart drop down', 'Clicked item', {
          label: 'Audiobook_id',
          value: $(event.currentTarget).parents('.shopping-cart-item').first().attr('data-audiobook-id'),
        });
      });

      shoppingCartDropdown.on('click', '.shopping-cart-item-audiobook-title', event => {
        bubEvents.track('Shopping cart drop down', 'Clicked item', {
          label: 'Audiobook_id',
          value: $(event.currentTarget).parents('.shopping-cart-item').first().attr('data-audiobook-id'),
        });
      });
    }
  }
});
